// src/components/CompareAnyTwo.jsx
import React, { useState, useEffect } from "react";
import API from "../services/api";
import CreatorDetails from "./CreatorDetails";
import "./CompareCreators.css";

export default function CompareAnyTwo() {
  const [topCreators, setTopCreators] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    API.get("/history/top_cy_score")
      .then(res => setTopCreators(res.data.top_creators))
      .catch(console.error);
  }, []);

  const toggleSelect = (creator) => {
    if (selected.find(c => c.creator_id === creator.creator_id)) {
      setSelected(selected.filter(c => c.creator_id !== creator.creator_id));
    } else if (selected.length < 2) {
      setSelected([...selected, creator]);
    }
  };

  if (selected.length === 2) {
    const [c1, c2] = selected;
    const isC1Better = c1.cy_score >= c2.cy_score;

    return (
      <div className="compare-row">
        <div
          className={`compare-card ${isC1Better ? "gold" : "black"}`}
          onClick={() => setSelected([c1])}
        >
          <h2>@{c1.username}</h2>
          <p>CY Score: {c1.cy_score}</p>
          <ul>
            <li>Momentum: {c1.momentum}</li>
            <li>Virality: {c1.virality}</li>
            <li>Consistency: {c1.consistency}</li>
            <li>Velocity: {c1.velocity}</li>
          </ul>
        </div>

        <div
          className={`compare-card ${isC1Better ? "black" : "gold"}`}
          onClick={() => setSelected([c2])}
        >
          <h2>@{c2.username}</h2>
          <p>CY Score: {c2.cy_score}</p>
          <ul>
            <li>Momentum: {c2.momentum}</li>
            <li>Virality: {c2.virality}</li>
            <li>Consistency: {c2.consistency}</li>
            <li>Velocity: {c2.velocity}</li>
          </ul>
        </div>

        {/* Details modal */}
        {selected.length === 1 && (
          <CreatorDetails
            creator={selected[0]}
            onClose={() => setSelected([])}
            onEdit={(c) => console.log("Edit", c)}
            onDelete={(id) => console.log("Delete", id)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="top-creators-grid">
      <h2>Select two creators to compare</h2>
      <div className="creator-nodes">
        {topCreators.map(c => (
          <div
            key={c.creator_id}
            className={`creator-node ${selected.find(s => s.creator_id === c.creator_id) ? "selected" : ""}`}
            onClick={() => toggleSelect(c)}
          >
            <span>@{c.username}</span>
            <small>CY Score: {c.cy_score}</small>
          </div>
        ))}
      </div>
    </div>
  );
}
